import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import countries from '@constants/countries'
import convertToBase64 from '@helpers/file-to-base64'
import passportPhotoExample from '@helpers/passport-photo-example'
import Swal from 'sweetalert2'
import islands from '@constants/islands'
import moment from 'moment'

const today = moment()
const yearsAgo = (minAge) => today.clone().subtract(minAge, 'years').toDate()

export default class YouthAmbassador extends React.Component {
  resource = '/youth_ambassadors'
  form_key = 'youth_ambassador'
  defaults = {}

  // Delete lines as needed
  free          = true
  skip_location = true
  hide_buttons  = false

  // before_apply = () => {
  //   Swal.fire({
  //     title: "NOTES",
  //     html: `<div>
  //       <p>Applicants must:</p>
  //       <ol style="text-align: left;display: flex;flex-direction: column;gap: 1rem;">
  //         <li>Must Be Bahamian</li>
  //         <li>Be between the ages of 16 to 29 (Applicants for High School Youth Ambassador 
  //         must be in 11th grade.)</li>
  //         <li>Possess a high level of multi-cultural awareness.</li>
  //         <li>Possess excellent written and verbal communication skills.</li>
  //       </ol>
  //       </div>`,
  //     icon: "info",
  //     // width: '60%',
  //     confirmButtonText: "I Understand",
  //   });
  // }

  // Shutdown applications
  componentDidMount() {
    Swal.fire(
      'Applications Closed',
      `
        Sorry, but this application form has reached its deadline.
      `,
      'info'
    )
  }


  before_apply = () => {
    return `
      Sorry, but this application form has reached its deadline.
    `
  }

  custom_actions = []

  foremost = null

  validate = async form => {
    const update = {}

    let index = 0

    if(form.supporting_documents_uploads[0]) {
      update.supporting_documents_uploads = []

      for (let row of form.supporting_documents_uploads) {
        const {
          file_upload,
          ...item
        } = row
        index ++

        if(file_upload){
          item.file_upload = await convertToBase64(file_upload);
          item.title = `Supporting Document - ${index}`;
          item.desc = `Supporting Document - ${item.description}`;
          update.supporting_documents_uploads.push(item);
        }
      }
  }

    return update
  }

  fields = form => [
    {
      name: 'i_am_applicant',
      label: 'I am applying for myself',
      type: 'select:bool'
    },

    "::Applicant Details",
    {
      name: 'applicant_first_name',
      label: 'First name',
      hide: form.i_am_applicant,
    },
    {
      name: 'applicant_middle_name',
      label: 'Middle name',
      hide: form.i_am_applicant,
      required: false,
    },
    {
      name: 'applicant_last_name',
      label: 'Last name',
      hide: form.i_am_applicant,
    },
    {
      name: 'applicant_dob',
      label: 'Date of birth',
      type: 'date',
      showYearDropdown: true,
      minDate: yearsAgo(29),
      maxDate: yearsAgo(16),
      hide: form.i_am_applicant,
    },
    {
      name: 'applicant_age',
      label: 'Age',
      type: 'integer',
      hide: true,
      view: {
        hide: form.i_am_applicant || !form.applicant_dob,
        value: (v) => {
          if (form.applicant_dob) {
            const today = new Date();
            const dob = new Date(form.applicant_dob)
            const monthCheck = today.getMonth() >= dob.getMonth()
            const dayCheck = today.getDate() >= dob.getDate()
            const minusYear = monthCheck && dayCheck ? 0 : 1
            return String(Math.trunc(Number((today.getFullYear() - dob.getFullYear()) - minusYear)))
          }
        }
      },
    },
    {
      name: 'contact_phone',
      label: 'Contact Phone Number #',
      type: 'phone',
    },
    {
      name: 'contact_email',
      label: 'Contact Email Address',
      type: 'email',
      required: false,
    },
    {
      name: 'home_address_island',
      label: 'Home Address Island',
      options: islands,
    },
    {
      name: 'home_address',
      label: 'Home Address',
      hint: 'Subdivision, Street, House # (#eg. Grants Town, Meadow St, #5)',
    },
    {
      name: 'marital_status',
      label: 'Marital Status',
      options: [
        'Single',
        'Married',
        'Divorced',
        'Widowed',
      ],
    },
    {
      name: 'number_of_children',
      label: 'Number of Children',
      type: 'integer',
      required: false,
      view: {
        value: (v) => v ? String(v) : 'N/A',
      }
    },
    {
      name: 'next_of_kin_list',
      label: 'Next of Kin',
      fields: [
        'first_name',
        {
          name: 'middle_name',
          label: 'Middle Name',
          required: false,
        },
        'last_name',
        {
          name: 'relationship',
          label: 'Relationship',
          options: [
            'Parent',
            'Sibling',
            'Spouse',
            'Child',
          ]
        },
        {
          name: 'phone_number',
          type: 'phone',
          required: false,
        },
        {
          name: 'email',
          type: 'email',
          required: false,
        },
        {
          name: 'date_of_birth',
          type: 'date',
          label: 'Date of Birth',
          showYearDropdown: true,
          required: false,
          view: {
            // value: (v, b, c, d) => {
            //   console.log('v', v, 'b', b, 'c', c, 'd', d)
            //   const dateFormatted = v?.indexOf('T') > -1 ? v?.split('T')[0] : v
            //   return dateFormatted
            // }
          },
        }
      ],
    },

    '::Organization Details',
    {
      name: 'designations_list',
      label: 'Designations',
      options: [
        { label: 'CARICOM Youth Ambassador [18 -29]', value: 'CARICOM Youth Ambassador' },
        { label: 'United Nations Youth Ambassador [18 -29]', value: 'United Nations Youth Ambassador' },
        { label: 'Commonwealth Youth Ambassador [18 -29]', value: 'Commonwealth Youth Ambassador' },
        { label: 'Youth Ambassador At Large [18 -29]', value: 'Youth Ambassador At Large' },
        { label: 'High School Youth Ambassador (Currently in high school)', value: 'High School Youth Ambassador' }
      ],
      multi: true,
    },
    {
      name: 'organization_list',
      label: 'List organizations that you are affiliated with.',
      fields: [
        {
          name: 'org_name',
          label: 'Name of Organization',
        },
      ]
    },

    '::Education Level',
    {
      name: 'highest_level_of_education',
      label: 'Highest Level of Education Completed',
      options: [
        'Primary School',
        'Secondary School',
        'Associates Degree',
        'Bachelor Degree',
        'Masters Degree',
        'Doctorate Degree',
        { value: 'Other', label: 'Other' },
      ],
    },
    {
      name: 'education_other_details',
      label: 'Please specify other level of education',
      hide: form.highest_level_of_education != 'Other',
    },

    '::Social Media Information',
    {
      name: 'social_media_list',
      label: 'Social Media Handles',
      fields: [
        {
          name: 'platform',
          label: 'Platform',
          options: [
            'Facebook',
            'Instagram',
            'Twitter',
            'LinkedIn',
            'Snapchat',
            'YouTube',
            'TikTok',
            'Other'
          ]
        },
        {
          name: 'platform_other',
          label: 'Please specify other platform',
          hide: !form.social_media_list?.some(s => s.platform === 'Other'),
          required: false,
        },
        {
          name: 'handle',
          label: 'Handle/Username',
        },
      ]
    },

    '::Work Experience',
    {
      name: 'work_experience_list',
      label: 'Please list your work experience',
      fields: [
        {
          name: 'employer_name',
          label: "Employer's/Company's Name",
        },
        {
          name: 'position_held',
          label: 'Position Held',
        },
        {
          name: 'start_date',
          type: 'date',
          label: 'Start Date',
          showYearDropdown: true,
          // view: {
          //   value: (v) => {
          //     const dateFormatted = v?.indexOf('T') > -1 ? v?.split('T')[0] : v
          //     return dateFormatted
          //   }
          // },
        },
        {
          name: 'end_date',
          type: 'date',
          label: 'End Date',
          showYearDropdown: true,
          required: false,
          // view: {
          //   value: (v) => {
          //     const dateFormatted = v?.indexOf('T') > -1 ? v?.split('T')[0] : 'Till Present Date'
          //     return dateFormatted
          //   }
          // },
        },
      ]
    },

    '::Special Skills, Talents & Goals',
    {
      name: 'special_skills_list',
      label: 'Please list your special skills & talents',
      fields: [
        {
          name: 'skill',
          label: 'Skill/Talent',
        },
        {
          name: 'description',
          label: 'Description',
          required: false,
        },
      ]
    },
    {
      name: 'life_goals_list',
      label: 'What are some of your life goals and ambitions?',
      fields: [
        { name: 'goal', label: 'Goal/Ambition', type: 'textarea' }
      ]
    },

    '::Youth Related Programs',
    {
      name: 'youth_work_list',
      label: 'What community/youth work are you engaged in within The Bahamas?',
      fields: [
        {
          name: 'program_name',
          label: 'Program Name',
        },
        {
          name: 'program_description',
          label: 'Program Description',
          required: false,
        },
      ]
    },
    {
      name: 'international_org_experience_list',
      label: 'List your experiences working or volunteering with International Organizations.',
      fields: [
        {
          name: 'country',
          label: 'Country',
          options: countries,
        },
        {
          name: 'organization',
          label: 'Organization Name',
        },
        {
          name: 'expierience_details',
          label: 'Details of Experience',
        },
      ]
    },
    {
      name: 'why_ambassador',
      label: 'What benefits do you expect to receive as an Ambassador?',
      type: 'textarea',
    },

    '::Essay',
    {
      name: 'essay_response',
      label: `In 500 words discuss what you think it means to be a Youth Ambassador and 
        how you would address issues affecting youth as an Ambassador.`,
      type: 'textarea',
    },

    '::Uploads',
    {
      name: 'photo_upload',
      type: 'file:image',
      label: 'Professional Photo',
      key: 'image.0',
      // required: false,
    },
    {
      name: 'identification_upload',
      type: 'file:image',
      label: 'Identification',
      key: 'image.1',
      tooltip: 'Only the information page is required',
      hint: passportPhotoExample,
    },
    {
      name: 'resume_upload',
      type: 'file:all',
      label: 'Resume',
      key: 'image.2',
      // required: false,
    },
    // Relevant Educational Certificates - Use Additional/Multiple Photo Attachments
    {
      name: 'supporting_documents_uploads',
      required: false,
      fields: [
        { 
          name: 'desc',
          label: 'Description of Document',
          required: false,
        },
        {
          name: 'file_upload',
          type: 'file:all',
          label: 'Document Upload',
          required: false,
        }
      ]
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
